import { fetch } from '@atlassian/eoc-fetch';
export const getTeamByIdEndpoint = teamId => fetch(`/v1/teams/${teamId}?includeImageUrls=true`);
export const getSidebarRightsEndpoint = teamId => {
  return fetch(`/v1/teams/${teamId}/menu-rights`);
};